// extracted by mini-css-extract-plugin
module.exports = {"container":"person-module--container--2jRGP","image":"person-module--image--w7Oam","bio":"person-module--bio--13bhy"};